import React, {useEffect} from "react";
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Paper, LinearProgress, Typography, Breadcrumbs, Grid,Drawer, Accordion, AccordionSummary, AccordionDetails } 
from '@mui/material';
import { useTheme, styled } from "@mui/material/styles";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Button from "../../components/CustomButtons/Button.jsx";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableContainer from '@mui/material/TableContainer';
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import LiveHelpTwoToneIcon from '@mui/icons-material/LiveHelpTwoTone';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import MultilineChartIcon from '@mui/icons-material/MultilineChart';
import AssignmentTurnedInTwoToneIcon from '@mui/icons-material/AssignmentTurnedInTwoTone';
import ForumIcon from '@mui/icons-material/Forum';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { baseUrl } from '../../components/shared/baseUrl';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  '&.MuiTableCell-body': {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
})); 

const StyledcardTitle = styled('div')({
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    align: "center"
});

const StyledcardCategory = styled('div')({
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
});

const styles = (theme) =>({
   
    list: {
      width: 250,
    },
    fullList: {
      width: 'auto',
    },
    table: {
      minWidth: 500,
    }
  });


    export default function ViewClass(props) {

    const [activity4, setactivity4] = React.useState({"Group Id":'', "Current Stage":'', "View activity4":''});
    var interval = null
    const [clas, setclas]=React.useState([])
    const [sess, setsess]=React.useState([])
    const [groups, setgroups]=React.useState([])
    const [groupSession, setgroupSession]=React.useState([])
    const [compUser, setcompUser]=React.useState([])
    const [preEfficacy, setpreEfficacy]=React.useState([])
    const [postEfficacy, setpostEfficacy]=React.useState([])
    const [feedback, setfeedback]=React.useState([])
    const [analyticStatus, setanalyticStatus]=React.useState([])
    const [analyticStatus2, setanalyticStatus2]=React.useState([])
    const [analyticStatus3, setanalyticStatus3]=React.useState([])
    const [analyticStatus4, setanalyticStatus4]=React.useState([])
    const [analyticStatus5, setanalyticStatus5]=React.useState([])
    const [analyticStatus6, setanalyticStatus6]=React.useState([])
    const [susibm, setsusibm]=React.useState([])
    const [loading, setloading]=React.useState(true)
    const [state, setState] = React.useState(false);
    const [gdetail, setgdetail] = React.useState({"userId":'',"currentStatus":''});
    const [status, setstatus]=React.useState([])
    const [expanded1, setExpanded1] = React.useState('');
    const { classId, sesId } = useParams();




    useEffect(() => {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();      
      
      const loadData=()=>{

      //const classId = classId;
      //const sesId = sesId;
      // console.log(props)
      axios.get(`${baseUrl}class/${classId}`)
      .then((response) => {
      setclas(response.data)
        const dat = Array.from(response.data.sessions)
        setstatus(dat)
      axios.get(`${baseUrl}pyinterpreter/profile`, { cancelToken: source.token })
      .then((response) =>{
        console.log(response.data)
        const sess=response.data.filter((ses)=> ses.sessionId == sesId)
        console.log(sess);
        setsess(sess)
        setgroups(response.data)
        var grpNo = 0;
        var groupStatus = [];
        var currStatus='';
        var preEfficacy=[];
        var postEfficacy=[];
        sess.map((grp) => {
          grpNo++;
          var preScore = 0
          var postScore = 0
          if(grp.preTest[0].bebras.includes(',')){
            var score=0
            var arr = grp.preTest[0].bebras.split(',')
            ///que1
          if(arr[0]==='Option2'){
            score = score+2
          }
          if(arr[1]=='Option1'){
            score = score+2
          }
          if(arr[2]=='Option1'){
            score = score+2
          }///que2
          if(arr[3]=='Option1'){
            score = score+1.5
          }
          if(arr[4]=='Option2'){
            score = score+1.5
          }
          if(arr[5]=='Option3'){
            score = score+1.5
          }
          if(arr[6]=='Option1'){
            score = score+1.5
          }///que3
          if(arr[7]==='Option1'){
            score = score+2
          }
          if(arr[8]=='Option4'){
            score = score+2
          }
          if(arr[9]=='Option1'){
            score = score+2
          }///que4
          if(arr[10]==='Option3'){
            score = score+3
          }
          if(arr[11]=='Option2'){
            score = score+3
          }
          ///que5
          if(arr[12]==='Option2'){
            score = score+4.5
          }
          if(arr[13]=='Option1'){
            score = score+4.5
          }///que6
          if(arr[14]==='Option1'){
            score = score+3
          }
          if(arr[15]=='Option1'){
            score = score+3
          }
          if(arr[16]=='Option4'){
            score = score+3
          }///que7
          if(arr[17]==='Option2'){
            score = score+3
          }
          if(arr[18]=='Option1'){
            score = score+3
          }
          if(arr[19]=='Option4'){
            score = score+3
          }///que8
          if(arr[20]==='Option1'){
            score = score+4.5
          }
          if(arr[21]=='Option3'){
            score = score+4.5
          }///que9
          if(arr[22]==='Option1'){
            score = score+12
          }///que10
          if(arr[23]==='Option2'){
            score = score+6
          }
          if(arr[24]=='Option2'){
            score = score+6
          }///que11
          if(arr[25]=='Option1'){
            score = score+3
          }
          if(arr[26]=='Option1'){
            score = score+3
          }
          if(arr[27]=='Option3'){
            score = score+3
          }
          if(arr[28]=='Option3'){
            score = score+3
          }///que12
          if(arr[29]==='Option3'){
            score = score+6
          }
          if(arr[30]=='Option3'){
            score = score+6
          }
          preScore=score
          }


//////////////////////////////analytics in activity1//////////////////////////////////////////////
var minutesDeco=0
var minutesPat=0
var minutesAbs=0
var minutesAlgo=0
var minutesAn=0
var totalAlternate=0
var minutesDecoAlt=0
var minutesPatAlt=0
var minutesAbsAlt=0
var minutesAlgoAlt=0
var minutesAnAlt=0
var hintScore=0

if(grp.postTest[0].efficacy.includes(',')==true){

////for decomposition
var startDeco = new Date(grp.activity1[0].decomposition[0].created) 
var finalDeco = new Date(grp.activity1[0].decomposition[0].finalTime)
if(startDeco<finalDeco){
    minutesDeco = (finalDeco - startDeco)/(1000*60)
}
///for alternate in decomposition
grp.activity1[0].decomposition[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesDecoAlt=totalAlternate
minutesDeco=minutesDeco-totalAlternate


////for pattern
    totalAlternate=0
    startDeco = new Date(grp.activity1[0].pattern[0].created) 
    finalDeco = new Date(grp.activity1[0].pattern[0].finalTime)
if(startDeco<finalDeco){
    minutesPat = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in pattern
grp.activity1[0].pattern[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesPatAlt=totalAlternate
minutesPat=minutesPat-totalAlternate


/////for abstraction
totalAlternate=0
startDeco = new Date(grp.activity1[0].abstraction[0].created) 
finalDeco = new Date(grp.activity1[0].abstraction[0].finalTime)
if(startDeco<finalDeco){
    minutesAbs = (finalDeco - startDeco)/(1000*60)
}

///for alternate in abstraction
grp.activity1[0].abstraction[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAbsAlt=totalAlternate
minutesAbs=minutesAbs-totalAlternate


/////for algorithm
totalAlternate=0
startDeco = new Date(grp.activity1[0].algorithm[0].created) 
finalDeco = new Date(grp.activity1[0].algorithm[0].finalTime)
if(startDeco<finalDeco){
    minutesAlgo = (finalDeco - startDeco)/(1000*60)
}

///for alternate in algorithm
grp.activity1[0].algorithm[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAlgoAlt=totalAlternate
minutesAlgo=minutesAlgo-totalAlternate

//////for analysis
totalAlternate=0
startDeco = new Date(grp.activity1[0].analysis[0].created) 
finalDeco = new Date(grp.activity1[0].analysis[0].finalTime)
if(startDeco<finalDeco){
    minutesAn = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in analysis            
minutesAnAlt=totalAlternate

hintScore=0;
if(grp.activity1[0].decomposition[0].levelOfHints=='Basic'){ 

  hintScore=hintScore+3
}
else if(grp.activity1[0].decomposition[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity1[0].decomposition[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity1[0].pattern[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity1[0].pattern[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity1[0].pattern[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity1[0].abstraction[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity1[0].abstraction[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity1[0].abstraction[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity1[0].algorithm[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity1[0].algorithm[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity1[0].algorithm[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity1[0].analysis[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity1[0].analysis[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity1[0].analysis[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}
var selAttempts=0

selAttempts= Number(grp.activity1[0].decomposition[0].enteredSolution.length)+Number(grp.activity1[0].pattern[0].enteredSolution.length)+Number(grp.activity1[0].abstraction[0].enteredSolution.length)+Number(grp.activity1[0].algorithm[0].enteredSolution.length)+Number(grp.activity1[0].analysis[0].enteredSolution.length)

if(grp.activity1[0].level=='easy'){
    selAttempts=selAttempts-48
}
else if(grp.activity1[0].level=='medium'){
    selAttempts=selAttempts-28
}
else{
    selAttempts=selAttempts-30
}

analyticStatus.push({
  userName:grp.userId,
  totAtt:Number(grp.activity1[0].decomposition[0].noOfattempts)+Number(grp.activity1[0].pattern[0].noOfattempts)+Number(grp.activity1[0].abstraction[0].noOfattempts)+Number(grp.activity1[0].algorithm[0].noOfattempts)+Number(grp.activity1[0].analysis[0].noOfattempts),
  totSelAtt:selAttempts,
  totHintScore:hintScore,
  decAttempts:grp.activity1[0].decomposition[0].noOfattempts,
  decHints:grp.activity1[0].decomposition[0].levelOfHints,
  decTime:minutesDeco.toFixed(2),
  decAltattempts:grp.activity1[0].decomposition[0].noOfaltattempts,
  decAlttime:minutesDecoAlt.toFixed(2),
  patAttempts:grp.activity1[0].pattern[0].noOfattempts,
  patHints:grp.activity1[0].pattern[0].levelOfHints,
  patTime:minutesPat.toFixed(2),
  patAltattempts:grp.activity1[0].pattern[0].noOfaltattempts,
  patAlttime:minutesPatAlt.toFixed(2),
  absAttempts:grp.activity1[0].abstraction[0].noOfattempts,
  absHints:grp.activity1[0].abstraction[0].levelOfHints,
  absTime:minutesAbs.toFixed(2),
  absAltattempts:grp.activity1[0].abstraction[0].noOfaltattempts,
  absAlttime:minutesAbsAlt.toFixed(2),
  algAttempts:grp.activity1[0].algorithm[0].noOfattempts,
  algHints:grp.activity1[0].algorithm[0].levelOfHints,
  algTime:minutesAlgo.toFixed(2),
  algAltattempts:grp.activity1[0].algorithm[0].noOfaltattempts,
  algAlttime:minutesAlgoAlt.toFixed(2),
  totAltSol:grp.activity1[0].decomposition[0].alternateSolution.length+grp.activity1[0].pattern[0].alternateSolution.length+grp.activity1[0].abstraction[0].alternateSolution.length+grp.activity1[0].algorithm[0].alternateSolution.length,
  decAltSol:grp.activity1[0].decomposition[0].alternateSolution.length,
  patAltSol:grp.activity1[0].pattern[0].alternateSolution.length,
  absAltSol:grp.activity1[0].abstraction[0].alternateSolution.length,
  algAltSol:grp.activity1[0].algorithm[0].alternateSolution.length,
  anaAttempts:grp.activity1[0].analysis[0].noOfattempts,
  anaHints:grp.activity1[0].analysis[0].levelOfHints,
  anaTime:minutesAn.toFixed(2),
  anaAltattempts:grp.activity1[0].analysis[0].noOfaltattempts,
  que1:grp.activity1[0].comparison[0].userText2,
  que2:grp.activity1[0].comparison[0].userText5,
  decSelAtt:grp.activity1[0].decomposition[0].enteredSolution.length,
  patSelAtt:grp.activity1[0].pattern[0].enteredSolution.length,
  absSelAtt:grp.activity1[0].abstraction[0].enteredSolution.length,
  algSelAtt:grp.activity1[0].algorithm[0].enteredSolution.length,
  anaSelAtt:grp.activity1[0].analysis[0].enteredSolution.length
})

console.log(analyticStatus)

//////////////////////////////analytics in activity2//////////////////////////////////////////////
////for decomposition
var startDeco = new Date(grp.activity2[0].decomposition[0].created) 
var finalDeco = new Date(grp.activity2[0].decomposition[0].finalTime)
if(startDeco<finalDeco){
    minutesDeco = (finalDeco - startDeco)/(1000*60)
}
///for alternate in decomposition
grp.activity2[0].decomposition[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesDecoAlt=totalAlternate
minutesDeco=minutesDeco-totalAlternate


////for pattern
    totalAlternate=0
    startDeco = new Date(grp.activity2[0].pattern[0].created) 
    finalDeco = new Date(grp.activity2[0].pattern[0].finalTime)
if(startDeco<finalDeco){
    minutesPat = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in pattern
grp.activity2[0].pattern[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesPatAlt=totalAlternate
minutesPat=minutesPat-totalAlternate

/////for abstraction
totalAlternate=0
startDeco = new Date(grp.activity2[0].abstraction[0].created) 
finalDeco = new Date(grp.activity2[0].abstraction[0].finalTime)
if(startDeco<finalDeco){
    minutesAbs = (finalDeco - startDeco)/(1000*60)
}

///for alternate in abstraction
grp.activity2[0].abstraction[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAbsAlt=totalAlternate
minutesAbs=minutesAbs-totalAlternate

/////for algorithm
totalAlternate=0
startDeco = new Date(grp.activity2[0].algorithm[0].created) 
finalDeco = new Date(grp.activity2[0].algorithm[0].finalTime)
if(startDeco<finalDeco){
    minutesAlgo = (finalDeco - startDeco)/(1000*60)
}

///for alternate in algorithm
grp.activity2[0].algorithm[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAlgoAlt=totalAlternate
minutesAlgo=minutesAlgo-totalAlternate

//////for analysis
totalAlternate=0
startDeco = new Date(grp.activity2[0].analysis[0].created) 
finalDeco = new Date(grp.activity2[0].analysis[0].finalTime)
if(startDeco<finalDeco){
    minutesAn = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in analysis            
minutesAnAlt=totalAlternate

hintScore=0;
if(grp.activity2[0].decomposition[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity2[0].decomposition[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity2[0].decomposition[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity2[0].pattern[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity2[0].pattern[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity2[0].pattern[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity2[0].abstraction[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity2[0].abstraction[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity2[0].abstraction[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity2[0].algorithm[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity2[0].algorithm[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity2[0].algorithm[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity2[0].analysis[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity2[0].analysis[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity2[0].analysis[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

selAttempts= Number(grp.activity2[0].decomposition[0].enteredSolution.length)+Number(grp.activity2[0].pattern[0].enteredSolution.length)+Number(grp.activity2[0].abstraction[0].enteredSolution.length)+Number(grp.activity2[0].algorithm[0].enteredSolution.length)+Number(grp.activity2[0].analysis[0].enteredSolution.length)

if(grp.activity2[0].level=='easy'){
    selAttempts=selAttempts-29
}
else if(grp.activity2[0].level=='medium'){
    selAttempts=selAttempts-23
}
else{
    selAttempts=selAttempts-68
}

analyticStatus2.push({
  userName:grp.userId,
  totAtt:Number(grp.activity2[0].decomposition[0].noOfattempts)+Number(grp.activity2[0].pattern[0].noOfattempts)+Number(grp.activity2[0].abstraction[0].noOfattempts)+Number(grp.activity2[0].algorithm[0].noOfattempts)+Number(grp.activity2[0].analysis[0].noOfattempts),
  totSelAtt:selAttempts,
  totHintScore:hintScore,
  decAttempts:grp.activity2[0].decomposition[0].noOfattempts,
  decHints:grp.activity2[0].decomposition[0].levelOfHints,
  decTime:minutesDeco.toFixed(2),
  decAltattempts:grp.activity2[0].decomposition[0].noOfaltattempts,
  decAlttime:minutesDecoAlt.toFixed(2),
  patAttempts:grp.activity2[0].pattern[0].noOfattempts,
  patHints:grp.activity2[0].pattern[0].levelOfHints,
  patTime:minutesPat.toFixed(2),
  patAltattempts:grp.activity2[0].pattern[0].noOfaltattempts,
  patAlttime:minutesPatAlt.toFixed(2),
  absAttempts:grp.activity2[0].abstraction[0].noOfattempts,
  absHints:grp.activity2[0].abstraction[0].levelOfHints,
  absTime:minutesAbs.toFixed(2),
  absAltattempts:grp.activity2[0].abstraction[0].noOfaltattempts,
  absAlttime:minutesAbsAlt.toFixed(2),
  algAttempts:grp.activity2[0].algorithm[0].noOfattempts,
  algHints:grp.activity2[0].algorithm[0].levelOfHints,
  algTime:minutesAlgo.toFixed(2),
  algAltattempts:grp.activity2[0].algorithm[0].noOfaltattempts,
  algAlttime:minutesAlgoAlt.toFixed(2),
  totAltSol:grp.activity2[0].decomposition[0].alternateSolution.length+grp.activity2[0].pattern[0].alternateSolution.length+grp.activity2[0].abstraction[0].alternateSolution.length+grp.activity2[0].algorithm[0].alternateSolution.length,
  decAltSol:grp.activity2[0].decomposition[0].alternateSolution.length,
  patAltSol:grp.activity2[0].pattern[0].alternateSolution.length,
  absAltSol:grp.activity2[0].abstraction[0].alternateSolution.length,
  algAltSol:grp.activity2[0].algorithm[0].alternateSolution.length,
  anaAttempts:grp.activity2[0].analysis[0].noOfattempts,
  anaHints:grp.activity2[0].analysis[0].levelOfHints,
  anaTime:minutesAn.toFixed(2),
  anaAltattempts:grp.activity2[0].analysis[0].noOfaltattempts,
  que1:grp.activity2[0].comparison[0].userText2,
  que2:grp.activity2[0].comparison[0].userText5,
  decSelAtt:grp.activity2[0].decomposition[0].enteredSolution.length,
  patSelAtt:grp.activity2[0].pattern[0].enteredSolution.length,
  absSelAtt:grp.activity2[0].abstraction[0].enteredSolution.length,
  algSelAtt:grp.activity2[0].algorithm[0].enteredSolution.length,
  anaSelAtt:grp.activity2[0].analysis[0].enteredSolution.length
})


//////////////////////////////analytics in activity3//////////////////////////////////////////////
////for decomposition
var startDeco = new Date(grp.activity3[0].decomposition[0].created) 
var finalDeco = new Date(grp.activity3[0].decomposition[0].finalTime)
if(startDeco<finalDeco){
    minutesDeco = (finalDeco - startDeco)/(1000*60)
}
///for alternate in decomposition
grp.activity3[0].decomposition[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesDecoAlt=totalAlternate
minutesDeco=minutesDeco-totalAlternate


////for pattern
    totalAlternate=0
    startDeco = new Date(grp.activity3[0].pattern[0].created) 
    finalDeco = new Date(grp.activity3[0].pattern[0].finalTime)
if(startDeco<finalDeco){
    minutesPat = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in pattern
grp.activity3[0].pattern[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesPatAlt=totalAlternate
minutesPat=minutesPat-totalAlternate

/////for abstraction
totalAlternate=0
startDeco = new Date(grp.activity3[0].abstraction[0].created) 
finalDeco = new Date(grp.activity3[0].abstraction[0].finalTime)
if(startDeco<finalDeco){
    minutesAbs = (finalDeco - startDeco)/(1000*60)
}

///for alternate in abstraction
grp.activity3[0].abstraction[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAbsAlt=totalAlternate
minutesAbs=minutesAbs-totalAlternate

/////for algorithm
totalAlternate=0
startDeco = new Date(grp.activity3[0].algorithm[0].created) 
finalDeco = new Date(grp.activity3[0].algorithm[0].finalTime)
if(startDeco<finalDeco){
    minutesAlgo = (finalDeco - startDeco)/(1000*60)
}

///for alternate in algorithm
grp.activity3[0].algorithm[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAlgoAlt=totalAlternate
minutesAlgo=minutesAlgo-totalAlternate

//////for analysis
totalAlternate=0
startDeco = new Date(grp.activity3[0].analysis[0].created) 
finalDeco = new Date(grp.activity3[0].analysis[0].finalTime)
if(startDeco<finalDeco){
    minutesAn = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in analysis            
minutesAnAlt=totalAlternate

hintScore=0;
if(grp.activity3[0].decomposition[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity3[0].decomposition[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity3[0].decomposition[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity3[0].pattern[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity3[0].pattern[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity3[0].pattern[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity3[0].abstraction[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity3[0].abstraction[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity3[0].abstraction[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity3[0].algorithm[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity3[0].algorithm[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity3[0].algorithm[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity3[0].analysis[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity3[0].analysis[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity3[0].analysis[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

selAttempts= Number(grp.activity3[0].decomposition[0].enteredSolution.length)+Number(grp.activity3[0].pattern[0].enteredSolution.length)+Number(grp.activity3[0].abstraction[0].enteredSolution.length)+Number(grp.activity3[0].algorithm[0].enteredSolution.length)+Number(grp.activity3[0].analysis[0].enteredSolution.length)

if(grp.activity3[0].level=='easy'){
    selAttempts=selAttempts-30
}
else if(grp.activity3[0].level=='medium'){
    selAttempts=selAttempts-32
}
else{
    selAttempts=selAttempts-44
}

analyticStatus3.push({
  userName:grp.userId,
  totAtt:Number(grp.activity3[0].decomposition[0].noOfattempts)+Number(grp.activity3[0].pattern[0].noOfattempts)+Number(grp.activity3[0].abstraction[0].noOfattempts)+Number(grp.activity3[0].algorithm[0].noOfattempts)+Number(grp.activity3[0].analysis[0].noOfattempts),
  totSelAtt:selAttempts,
  totHintScore:hintScore,
  decAttempts:grp.activity3[0].decomposition[0].noOfattempts,
  decHints:grp.activity3[0].decomposition[0].levelOfHints,
  decTime:minutesDeco.toFixed(2),
  decAltattempts:grp.activity3[0].decomposition[0].noOfaltattempts,
  decAlttime:minutesDecoAlt.toFixed(2),
  patAttempts:grp.activity3[0].pattern[0].noOfattempts,
  patHints:grp.activity3[0].pattern[0].levelOfHints,
  patTime:minutesPat.toFixed(2),
  patAltattempts:grp.activity3[0].pattern[0].noOfaltattempts,
  patAlttime:minutesPatAlt.toFixed(2),
  absAttempts:grp.activity3[0].abstraction[0].noOfattempts,
  absHints:grp.activity3[0].abstraction[0].levelOfHints,
  absTime:minutesAbs.toFixed(2),
  absAltattempts:grp.activity3[0].abstraction[0].noOfaltattempts,
  absAlttime:minutesAbsAlt.toFixed(2),
  algAttempts:grp.activity3[0].algorithm[0].noOfattempts,
  algHints:grp.activity3[0].algorithm[0].levelOfHints,
  algTime:minutesAlgo.toFixed(2),
  algAltattempts:grp.activity3[0].algorithm[0].noOfaltattempts,
  algAlttime:minutesAlgoAlt.toFixed(2),
  totAltSol:grp.activity3[0].decomposition[0].alternateSolution.length+grp.activity3[0].pattern[0].alternateSolution.length+grp.activity3[0].abstraction[0].alternateSolution.length+grp.activity3[0].algorithm[0].alternateSolution.length,
  decAltSol:grp.activity3[0].decomposition[0].alternateSolution.length,
  patAltSol:grp.activity3[0].pattern[0].alternateSolution.length,
  absAltSol:grp.activity3[0].abstraction[0].alternateSolution.length,
  algAltSol:grp.activity3[0].algorithm[0].alternateSolution.length,
  anaAttempts:grp.activity3[0].analysis[0].noOfattempts,
  anaHints:grp.activity3[0].analysis[0].levelOfHints,
  anaTime:minutesAn.toFixed(2),
  anaAltattempts:grp.activity3[0].analysis[0].noOfaltattempts,
  que1:grp.activity3[0].comparison[0].userText2,
  que2:grp.activity3[0].comparison[0].userText5,
  decSelAtt:grp.activity3[0].decomposition[0].enteredSolution.length,
  patSelAtt:grp.activity3[0].pattern[0].enteredSolution.length,
  absSelAtt:grp.activity3[0].abstraction[0].enteredSolution.length,
  algSelAtt:grp.activity3[0].algorithm[0].enteredSolution.length,
  anaSelAtt:grp.activity3[0].analysis[0].enteredSolution.length
})



//////////////////////////////analytics in activity4//////////////////////////////////////////////

////for decomposition
var startDeco = new Date(grp.activity4[0].decomposition[0].created) 
var finalDeco = new Date(grp.activity4[0].decomposition[0].finalTime)
if(startDeco<finalDeco){
    minutesDeco = (finalDeco - startDeco)/(1000*60)
}
///for alternate in decomposition
grp.activity4[0].decomposition[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesDecoAlt=totalAlternate
minutesDeco=minutesDeco-totalAlternate


////for pattern
    totalAlternate=0
    startDeco = new Date(grp.activity4[0].pattern[0].created) 
    finalDeco = new Date(grp.activity4[0].pattern[0].finalTime)
if(startDeco<finalDeco){
    minutesPat = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in pattern
grp.activity4[0].pattern[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesPatAlt=totalAlternate
minutesPat=minutesPat-totalAlternate

/////for abstraction
totalAlternate=0
startDeco = new Date(grp.activity4[0].abstraction[0].created) 
finalDeco = new Date(grp.activity4[0].abstraction[0].finalTime)
if(startDeco<finalDeco){
    minutesAbs = (finalDeco - startDeco)/(1000*60)
}

///for alternate in abstraction
grp.activity4[0].abstraction[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAbsAlt=totalAlternate
minutesAbs=minutesAbs-totalAlternate

/////for algorithm
totalAlternate=0
startDeco = new Date(grp.activity4[0].algorithm[0].created) 
finalDeco = new Date(grp.activity4[0].algorithm[0].finalTime)
if(startDeco<finalDeco){
    minutesAlgo = (finalDeco - startDeco)/(1000*60)
}

///for alternate in algorithm
grp.activity4[0].algorithm[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAlgoAlt=totalAlternate
minutesAlgo=minutesAlgo-totalAlternate

//////for analysis
totalAlternate=0
startDeco = new Date(grp.activity4[0].analysis[0].created) 
finalDeco = new Date(grp.activity4[0].analysis[0].finalTime)
if(startDeco<finalDeco){
    minutesAn = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in analysis            
minutesAnAlt=totalAlternate

hintScore=0;
if(grp.activity4[0].decomposition[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity4[0].decomposition[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity4[0].decomposition[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity4[0].pattern[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity4[0].pattern[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity4[0].pattern[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity4[0].abstraction[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity4[0].abstraction[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity4[0].abstraction[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity4[0].algorithm[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity4[0].algorithm[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity4[0].algorithm[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity4[0].analysis[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity4[0].analysis[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity4[0].analysis[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

selAttempts= Number(grp.activity4[0].decomposition[0].enteredSolution.length)+Number(grp.activity4[0].pattern[0].enteredSolution.length)+Number(grp.activity4[0].abstraction[0].enteredSolution.length)+Number(grp.activity4[0].algorithm[0].enteredSolution.length)+Number(grp.activity4[0].analysis[0].enteredSolution.length)

if(grp.activity4[0].level=='easy'){
    selAttempts=selAttempts-47
}
else if(grp.activity4[0].level=='medium'){
    selAttempts=selAttempts-70
}
else{
    selAttempts=selAttempts-80
}

analyticStatus4.push({
  userName:grp.userId,
  totAtt:Number(grp.activity4[0].decomposition[0].noOfattempts)+Number(grp.activity4[0].pattern[0].noOfattempts)+Number(grp.activity4[0].abstraction[0].noOfattempts)+Number(grp.activity4[0].algorithm[0].noOfattempts)+Number(grp.activity4[0].analysis[0].noOfattempts),
  totSelAtt:selAttempts,
  totHintScore:hintScore,
  decAttempts:grp.activity4[0].decomposition[0].noOfattempts,
  decAltattempts:grp.activity4[0].decomposition[0].noOfaltattempts,
  decHints:grp.activity4[0].decomposition[0].levelOfHints,
  decTime:minutesDeco.toFixed(2),
  decAlttime:minutesDecoAlt.toFixed(2),
  patAttempts:grp.activity4[0].pattern[0].noOfattempts,
  patAltattempts:grp.activity4[0].pattern[0].noOfaltattempts,
  patHints:grp.activity4[0].pattern[0].levelOfHints,
  patTime:minutesPat.toFixed(2),
  patAlttime:minutesPatAlt.toFixed(2),
  absAttempts:grp.activity4[0].abstraction[0].noOfattempts,
  absAltattempts:grp.activity4[0].abstraction[0].noOfaltattempts,
  absHints:grp.activity4[0].abstraction[0].levelOfHints,
  absTime:minutesAbs.toFixed(2),
  absAlttime:minutesAbsAlt.toFixed(2),
  algAttempts:grp.activity4[0].algorithm[0].noOfattempts,
  algAltattempts:grp.activity4[0].algorithm[0].noOfaltattempts,
  algHints:grp.activity4[0].algorithm[0].levelOfHints,
  algTime:minutesAlgo.toFixed(2),
  algAlttime:minutesAlgoAlt.toFixed(2),
  totAltSol:grp.activity4[0].decomposition[0].alternateSolution.length+grp.activity4[0].pattern[0].alternateSolution.length+grp.activity4[0].abstraction[0].alternateSolution.length+grp.activity4[0].algorithm[0].alternateSolution.length,
  decAltSol:grp.activity4[0].decomposition[0].alternateSolution.length,
  patAltSol:grp.activity4[0].pattern[0].alternateSolution.length,
  absAltSol:grp.activity4[0].abstraction[0].alternateSolution.length,
  algAltSol:grp.activity4[0].algorithm[0].alternateSolution.length,
  anaAttempts:grp.activity4[0].analysis[0].noOfattempts,
  anaAltattempts:grp.activity4[0].analysis[0].noOfaltattempts,
  anaHints:grp.activity4[0].analysis[0].levelOfHints,
  anaTime:minutesAn.toFixed(2),
  que1:grp.activity4[0].comparison[0].userText2,
  que2:grp.activity4[0].comparison[0].userText5,
  decSelAtt:grp.activity4[0].decomposition[0].enteredSolution.length,
  patSelAtt:grp.activity4[0].pattern[0].enteredSolution.length,
  absSelAtt:grp.activity4[0].abstraction[0].enteredSolution.length,
  algSelAtt:grp.activity4[0].algorithm[0].enteredSolution.length,
  anaSelAtt:grp.activity4[0].analysis[0].enteredSolution.length
})


//////////////////////////////analytics in activity5//////////////////////////////////////////////

////for decomposition
var startDeco = new Date(grp.activity5[0].decomposition[0].created) 
var finalDeco = new Date(grp.activity5[0].decomposition[0].finalTime)
if(startDeco<finalDeco){
    minutesDeco = (finalDeco - startDeco)/(1000*60)
}
///for alternate in decomposition
grp.activity5[0].decomposition[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesDecoAlt=totalAlternate
minutesDeco=minutesDeco-totalAlternate


////for pattern
    totalAlternate=0
    startDeco = new Date(grp.activity5[0].pattern[0].created) 
    finalDeco = new Date(grp.activity5[0].pattern[0].finalTime)
if(startDeco<finalDeco){
    minutesPat = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in pattern
grp.activity5[0].pattern[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesPatAlt=totalAlternate
minutesPat=minutesPat-totalAlternate

/////for abstraction
totalAlternate=0
startDeco = new Date(grp.activity5[0].abstraction[0].created) 
finalDeco = new Date(grp.activity5[0].abstraction[0].finalTime)
if(startDeco<finalDeco){
    minutesAbs = (finalDeco - startDeco)/(1000*60)
}

///for alternate in abstraction
grp.activity5[0].abstraction[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAbsAlt=totalAlternate
minutesAbs=minutesAbs-totalAlternate

/////for algorithm
totalAlternate=0
startDeco = new Date(grp.activity5[0].algorithm[0].created) 
finalDeco = new Date(grp.activity5[0].algorithm[0].finalTime)
if(startDeco<finalDeco){
    minutesAlgo = (finalDeco - startDeco)/(1000*60)
}

///for alternate in algorithm
grp.activity5[0].algorithm[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAlgoAlt=totalAlternate
minutesAlgo=minutesAlgo-totalAlternate

//////for analysis
totalAlternate=0
startDeco = new Date(grp.activity5[0].analysis[0].created) 
finalDeco = new Date(grp.activity5[0].analysis[0].finalTime)
if(startDeco<finalDeco){
    minutesAn = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in analysis            
minutesAnAlt=totalAlternate

hintScore=0;
if(grp.activity5[0].decomposition[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity5[0].decomposition[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity5[0].decomposition[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity5[0].pattern[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity5[0].pattern[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity5[0].pattern[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity5[0].abstraction[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity5[0].abstraction[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity5[0].abstraction[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity5[0].algorithm[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity5[0].algorithm[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity5[0].algorithm[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity5[0].analysis[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity5[0].analysis[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity5[0].analysis[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

selAttempts= Number(grp.activity5[0].decomposition[0].enteredSolution.length)+Number(grp.activity5[0].pattern[0].enteredSolution.length)+Number(grp.activity5[0].abstraction[0].enteredSolution.length)+Number(grp.activity5[0].algorithm[0].enteredSolution.length)+Number(grp.activity5[0].analysis[0].enteredSolution.length)

if(grp.activity5[0].level=='easy'){
    selAttempts=selAttempts-26
}
else if(grp.activity5[0].level=='medium'){
    selAttempts=selAttempts-30
}
else{
    selAttempts=selAttempts-21
}

analyticStatus5.push({
  userName:grp.userId,
  totAtt:Number(grp.activity5[0].decomposition[0].noOfattempts)+Number(grp.activity5[0].pattern[0].noOfattempts)+Number(grp.activity5[0].abstraction[0].noOfattempts)+Number(grp.activity5[0].algorithm[0].noOfattempts)+Number(grp.activity5[0].analysis[0].noOfattempts),
  totSelAtt:selAttempts,
  totHintScore:hintScore,
  decAttempts:grp.activity5[0].decomposition[0].noOfattempts,
  decAltattempts:grp.activity5[0].decomposition[0].noOfaltattempts,
  decHints:grp.activity5[0].decomposition[0].levelOfHints,
  decTime:minutesDeco.toFixed(2),
  decAlttime:minutesDecoAlt.toFixed(2),
  patAttempts:grp.activity5[0].pattern[0].noOfattempts,
  patAltattempts:grp.activity5[0].pattern[0].noOfaltattempts,
  patHints:grp.activity5[0].pattern[0].levelOfHints,
  patTime:minutesPat.toFixed(2),
  patAlttime:minutesPatAlt.toFixed(2),
  absAttempts:grp.activity5[0].abstraction[0].noOfattempts,
  absAltattempts:grp.activity5[0].abstraction[0].noOfaltattempts,
  absHints:grp.activity5[0].abstraction[0].levelOfHints,
  absTime:minutesAbs.toFixed(2),
  absAlttime:minutesAbsAlt.toFixed(2),
  algAttempts:grp.activity5[0].algorithm[0].noOfattempts,
  algAltattempts:grp.activity5[0].algorithm[0].noOfaltattempts,
  algHints:grp.activity5[0].algorithm[0].levelOfHints,
  algTime:minutesAlgo.toFixed(2),
  algAlttime:minutesAlgoAlt.toFixed(2),
  totAltSol:grp.activity5[0].decomposition[0].alternateSolution.length+grp.activity5[0].pattern[0].alternateSolution.length+grp.activity5[0].abstraction[0].alternateSolution.length+grp.activity5[0].algorithm[0].alternateSolution.length,
  decAltSol:grp.activity5[0].decomposition[0].alternateSolution.length,
  patAltSol:grp.activity5[0].pattern[0].alternateSolution.length,
  absAltSol:grp.activity5[0].abstraction[0].alternateSolution.length,
  algAltSol:grp.activity5[0].algorithm[0].alternateSolution.length,
  anaAttempts:grp.activity5[0].analysis[0].noOfattempts,
  anaAltattempts:grp.activity5[0].analysis[0].noOfaltattempts,
  anaHints:grp.activity5[0].analysis[0].levelOfHints,
  anaTime:minutesAn.toFixed(2),
  que1:grp.activity5[0].comparison[0].userText2,
  que2:grp.activity5[0].comparison[0].userText5,
  decSelAtt:grp.activity5[0].decomposition[0].enteredSolution.length,
  patSelAtt:grp.activity5[0].pattern[0].enteredSolution.length,
  absSelAtt:grp.activity5[0].abstraction[0].enteredSolution.length,
  algSelAtt:grp.activity5[0].algorithm[0].enteredSolution.length,
  anaSelAtt:grp.activity5[0].analysis[0].enteredSolution.length
})

//////////////////////////////analytics in activity6//////////////////////////////////////////////

////for decomposition
var startDeco = new Date(grp.activity6[0].decomposition[0].created) 
var finalDeco = new Date(grp.activity6[0].decomposition[0].finalTime)
if(startDeco<finalDeco){
    minutesDeco = (finalDeco - startDeco)/(1000*60)
}
///for alternate in decomposition
grp.activity6[0].decomposition[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesDecoAlt=totalAlternate
minutesDeco=minutesDeco-totalAlternate


////for pattern
    totalAlternate=0
    startDeco = new Date(grp.activity6[0].pattern[0].created) 
    finalDeco = new Date(grp.activity6[0].pattern[0].finalTime)
if(startDeco<finalDeco){
    minutesPat = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in pattern
grp.activity6[0].pattern[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesPatAlt=totalAlternate
minutesPat=minutesPat-totalAlternate

/////for abstraction
totalAlternate=0
startDeco = new Date(grp.activity6[0].abstraction[0].created) 
finalDeco = new Date(grp.activity6[0].abstraction[0].finalTime)
if(startDeco<finalDeco){
    minutesAbs = (finalDeco - startDeco)/(1000*60)
}

///for alternate in abstraction
grp.activity6[0].abstraction[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAbsAlt=totalAlternate
minutesAbs=minutesAbs-totalAlternate

/////for algorithm
totalAlternate=0
startDeco = new Date(grp.activity6[0].algorithm[0].created) 
finalDeco = new Date(grp.activity6[0].algorithm[0].finalTime)
if(startDeco<finalDeco){
    minutesAlgo = (finalDeco - startDeco)/(1000*60)
}

///for alternate in algorithm
grp.activity6[0].algorithm[0].alternateSolution.map((text,index)=>{
    var altstart = new Date(text.created)
    var altfinal = new Date(text.finalTime)
    if(altstart<altfinal){
        var diff = (altfinal - altstart)/(1000*60)
    }
    totalAlternate=totalAlternate+diff
})
minutesAlgoAlt=totalAlternate
minutesAlgo=minutesAlgo-totalAlternate

//////for analysis
totalAlternate=0
startDeco = new Date(grp.activity6[0].analysis[0].created) 
finalDeco = new Date(grp.activity6[0].analysis[0].finalTime)
if(startDeco<finalDeco){
    minutesAn = (finalDeco - startDeco)/(1000*60)
} 
///for alternate in analysis            
minutesAnAlt=totalAlternate

hintScore=0;
if(grp.activity6[0].decomposition[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity6[0].decomposition[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity6[0].decomposition[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity6[0].pattern[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity6[0].pattern[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity6[0].pattern[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity6[0].abstraction[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity6[0].abstraction[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity6[0].abstraction[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity6[0].algorithm[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity6[0].algorithm[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity6[0].algorithm[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

if(grp.activity6[0].analysis[0].levelOfHints=='Basic'){
  hintScore=hintScore+3
}
else if(grp.activity6[0].analysis[0].levelOfHints=='Intermediate'){
  hintScore=hintScore+2
}
else if(grp.activity6[0].analysis[0].levelOfHints=='Advanced'){
  hintScore=hintScore+1
}

selAttempts= Number(grp.activity6[0].decomposition[0].enteredSolution.length)+Number(grp.activity6[0].pattern[0].enteredSolution.length)+Number(grp.activity6[0].abstraction[0].enteredSolution.length)+Number(grp.activity6[0].algorithm[0].enteredSolution.length)+Number(grp.activity6[0].analysis[0].enteredSolution.length)

if(grp.activity6[0].level=='easy'){
    selAttempts=selAttempts-60
}
else if(grp.activity6[0].level=='medium'){
    selAttempts=selAttempts-48
}
else{
    selAttempts=selAttempts-47
}

analyticStatus6.push({
  userName:grp.userId,
  totAtt:Number(grp.activity6[0].decomposition[0].noOfattempts)+Number(grp.activity6[0].pattern[0].noOfattempts)+Number(grp.activity6[0].abstraction[0].noOfattempts)+Number(grp.activity6[0].algorithm[0].noOfattempts)+Number(grp.activity6[0].analysis[0].noOfattempts),
  totSelAtt: selAttempts,
  totHintScore:hintScore,
  decAttempts:grp.activity6[0].decomposition[0].noOfattempts,
  decAltattempts:grp.activity6[0].decomposition[0].noOfaltattempts,
  decHints:grp.activity6[0].decomposition[0].levelOfHints,
  decTime:minutesDeco.toFixed(2),
  decAlttime:minutesDecoAlt.toFixed(2),
  patAttempts:grp.activity6[0].pattern[0].noOfattempts,
  patAltattempts:grp.activity6[0].pattern[0].noOfaltattempts,
  patHints:grp.activity6[0].pattern[0].levelOfHints,
  patTime:minutesPat.toFixed(2),
  patAlttime:minutesPatAlt.toFixed(2),
  absAttempts:grp.activity6[0].abstraction[0].noOfattempts,
  absAltattempts:grp.activity6[0].abstraction[0].noOfaltattempts,
  absHints:grp.activity6[0].abstraction[0].levelOfHints,
  absTime:minutesAbs.toFixed(2),
  absAlttime:minutesAbsAlt.toFixed(2),
  algAttempts:grp.activity6[0].algorithm[0].noOfattempts,
  algAltattempts:grp.activity6[0].algorithm[0].noOfaltattempts,
  algHints:grp.activity6[0].algorithm[0].levelOfHints,
  algTime:minutesAlgo.toFixed(2),
  algAlttime:minutesAlgoAlt.toFixed(2),
  totAltSol:grp.activity6[0].decomposition[0].alternateSolution.length+grp.activity6[0].pattern[0].alternateSolution.length+grp.activity6[0].abstraction[0].alternateSolution.length+grp.activity6[0].algorithm[0].alternateSolution.length,
  decAltSol:grp.activity6[0].decomposition[0].alternateSolution.length,
  patAltSol:grp.activity6[0].pattern[0].alternateSolution.length,
  absAltSol:grp.activity6[0].abstraction[0].alternateSolution.length,
  algAltSol:grp.activity6[0].algorithm[0].alternateSolution.length,
  anaAttempts:grp.activity6[0].analysis[0].noOfattempts,
  anaAltattempts:grp.activity6[0].analysis[0].noOfaltattempts,
  anaHints:grp.activity6[0].analysis[0].levelOfHints,
  anaTime:minutesAn.toFixed(2),
  que1:grp.activity6[0].comparison[0].userText2,
  que2:grp.activity6[0].comparison[0].userText5,
  decSelAtt:grp.activity6[0].decomposition[0].enteredSolution.length,
  patSelAtt:grp.activity6[0].pattern[0].enteredSolution.length,
  absSelAtt:grp.activity6[0].abstraction[0].enteredSolution.length,
  algSelAtt:grp.activity6[0].algorithm[0].enteredSolution.length,
  anaSelAtt:grp.activity6[0].analysis[0].enteredSolution.length
})

}

//////////////////////////////////////////////////////////////////////////////////////

          if(grp.postTest[0].bebras.includes(',')){
            var arr = grp.postTest[0].bebras.split(',')
            var score=0;
            ///que1
            if(arr[0]==='Option3'){
              score = score+3
            }
            if(arr[1]=='Option2'){
              score = score+3
            }///que2
            if(arr[2]=='Option3'){
              score = score+6
            }//que3
            if(arr[3]=='Option4'){
              score = score+2
            }
            if(arr[4]=='Option2'){
              score = score+2
            }
            if(arr[5]=='Option2'){
              score = score+2
            }//que4
            if(arr[6]=='Option1'){
              score = score+2
            }
            if(arr[7]==='Option3'){
              score = score+2
            }
            if(arr[8]=='Option4'){
              score = score+2
            }//que5
            if(arr[9]=='Option3'){
              score = score+3
            }
            if(arr[10]==='Option2'){
              score = score+3
            }
            if(arr[11]=='Option4'){
              score = score+3
            }
            ///que6
            if(arr[12]==='Option3'){
              score = score+4.5
            }
            if(arr[13]=='Option3'){
              score = score+4.5
            }///que7
            if(arr[14]==='Option1'){
              score = score+3
            }
            if(arr[15]=='Option2'){
              score = score+3
            }
            if(arr[16]=='Option2'){
              score = score+3
            }///que8
            if(arr[17]==='Option2'){
              score = score+4.5
            }
            if(arr[18]=='Option1'){
              score = score+4.5
            }//que9
            if(arr[19]=='Option3'){
              score = score+4
            }
            if(arr[20]==='Option2'){
              score = score+4
            }
            if(arr[21]=='Option3'){
              score = score+4
            }///que10
            if(arr[22]==='Option1'){
              score = score+4
            }
            if(arr[23]==='Option1'){
              score = score+4
            }
            if(arr[24]=='Option3'){
              score = score+4
            }///que11
            if(arr[25]=='Option3'){
              score = score+4
            }
            if(arr[26]=='Option3'){
              score = score+4
            }
            if(arr[27]=='Option2'){
              score = score+4
            }///que12
            if(arr[28]=='Option2'){
              score = score+4
            }
            if(arr[29]==='Option1'){
              score = score+4
            }
            if(arr[30]=='Option3'){
              score = score+4
            }
            
            postScore=score
          }
          var name='';
          var age = 0;
          var section = '';
          var gender='Male';
          var std='IX';
          var preClass=false;
          var progLang = ''
          
          if(grp.preTest[0].initial.includes(',')==true){
            var narr = grp.preTest[0].initial.split(',')
            name = narr[0]
            gender = narr[2]
            std = narr[3]
            section = narr[4]
            preClass = narr[5]
            progLang = narr[6]
            age = getAge(narr[1])
            console.log('Age: '+age+' '+narr[1])
          }
          var totscore = 0
          if(grp.postTest[0].ibmsus.includes(';')==true){
            var scr = grp.postTest[0].ibmsus.split(';')
            scr.map((val, index)=>{
              if(index<10){
              if((index+1)%2==0){
                totscore = totscore+(5-getScore(val))
              }
              else{
                totscore = totscore+(getScore(val)-1)
              }
              console.log(getScore(val))
            }
            })
            
          }
          if(grp.preTest[0].efficacy.includes(',')==true){
            var preEff = grp.preTest[0].efficacy.split(',')
            preEfficacy.push({
              userName:grp.userId,
              q1:getScore(preEff[0]),
              q2:getScore(preEff[1]),
              q3:getScore(preEff[2]),
              q4:getScore(preEff[3]),
              q5:getScore(preEff[4]),
              q6:getScore(preEff[5]),
              q7:getScore(preEff[6]),
              q8:getScore(preEff[7]),
              q9:getScore(preEff[8]),
              q10:getScore(preEff[9]),
              q11:getScore(preEff[10]),
              q12:getScore(preEff[11]),
              q13:getScore(preEff[12]),
              q14:getScore(preEff[13]),
              q15:getScore(preEff[14]),
              q16:getScore(preEff[15]),
              q17:getScore(preEff[16]),
              q18:getScore(preEff[17])
            })
          }

          if(grp.postTest[0].efficacy.includes(',')==true){
            var postEff = grp.preTest[0].efficacy.split(',')
            postEfficacy.push({
              userName:grp.userId,
              q1:getScore(postEff[0]),
              q2:getScore(postEff[1]),
              q3:getScore(postEff[2]),
              q4:getScore(postEff[3]),
              q5:getScore(postEff[4]),
              q6:getScore(postEff[5]),
              q7:getScore(postEff[6]),
              q8:getScore(postEff[7]),
              q9:getScore(postEff[8]),
              q10:getScore(postEff[9]),
              q11:getScore(postEff[10]),
              q12:getScore(postEff[11]),
              q13:getScore(postEff[12]),
              q14:getScore(postEff[13]),
              q15:getScore(postEff[14]),
              q16:getScore(postEff[15]),
              q17:getScore(postEff[16]),
              q18:getScore(postEff[17])
            })
          }

          if(grp.postTest[0].ibmsus.includes(';')==true){
            var postEff = grp.postTest[0].ibmsus.split(';')
            susibm.push({
              userName:grp.userId,
              q1:getScore(postEff[0]),
              q2:getScore(postEff[1]),
              q3:getScore(postEff[2]),
              q4:getScore(postEff[3]),
              q5:getScore(postEff[4]),
              q6:getScore(postEff[5]),
              q7:getScore(postEff[6]),
              q8:getScore(postEff[7]),
              q9:getScore(postEff[8]),
              q10:getScore(postEff[9]),
              score:totscore
            })
            feedback.push({
              userName:grp.userId,
              q1:postEff[10],
              q2:postEff[11],
              q3:postEff[12],
              q4:postEff[13],
              q5:postEff[14],
              q6:postEff[15],
              q7:postEff[16],
              q8:postEff[17],
              q9:postEff[18],
              q10:postEff[19],
            })
          }

          

          if(grp.postTest[0].completed==true){
            compUser.push({
              id:grp._id,
              userId:'User'+grpNo,
              userName:grp.userId,
              type:grp.type,
              supportChat: grp.support,
              lastViewSupport:grp.lastViewSupport,
              preTestScore:preScore,
              postTestScore:postScore,
              nam:name,
              age:age,
              gender:gender,
              std:std,
              section:section,
              preClass:preClass,
              progLang:progLang,
              susScore:totscore,
              completed:grp.postTest[0].completed
            })
          }

          if(grp.currentActivity!==''){
              currStatus=grp.currentActivity
        
            groupStatus.push({
              id:grp._id,
              userId:'User'+grpNo,
              userName:grp.userId,
              type:grp.type,
              supportChat: grp.support,
              lastViewSupport:grp.lastViewSupport,
              currentStatus:currStatus,
              preTestScore:preScore,
              postTestScore:postScore,
              nam:name,
              age:age,
              gender:gender,
              std:std,
              section:section,
              preClass:preClass,
              progLang:progLang,
              susScore:totscore,
              completed:grp.postTest[0].completed
            })

          }
          else{
            groupStatus.push({
              id:grp._id,
              userId:'User'+grpNo,
              userName:grp.userId,
              type:grp.type,
              supportChat: grp.support,
              lastViewSupport:grp.lastViewSupport,
              currentStatus:'activity1',
              preTestScore:preScore,
              postTestScore:postScore,
              nam:name,
              age:age,
              gender:gender,
              std:std,
              section:section,
              preClass:preClass,
              progLang:progLang,
              susScore:totscore,
              completed:grp.postTest[0].completed
            })

          }
          

        })
        var sumpreCT=0
        var sumpostCT=0
        var sumIBMCT=0
        var preCont=0
        var postCont=0
        var preExp=0
        var postExp=0
        var nCont=0
        var nExp=0
        compUser.map((val,index)=>{
          sumpreCT=sumpreCT+Number(val.preTestScore)
          sumpostCT=sumpostCT+Number(val.postTestScore)
          sumIBMCT=sumIBMCT+Number(val.susScore)
          if(val.type=='control'){
            nCont=nCont+1
            preCont=preCont+Number(val.preTestScore)
            postCont=postCont+Number(val.postTestScore)
          }
          else{
            nExp=nExp+1
            preExp=preExp+Number(val.preTestScore)
            postExp=postExp+Number(val.postTestScore)
          }
        })
        compUser.push({
          id:'123',
          userId:'Mean',
          userName:'Mean',
          type:'',
          supportChat: '',
          lastViewSupport:'',
          nControl:0,
          nExperiment:0,
          gender:Number(preCont/nCont).toFixed(2),
          section:Number(postCont/nCont).toFixed(2),
          preClass:Number(preExp/nExp).toFixed(2),
          progLang:Number(postExp/nExp).toFixed(2),
          preTestScore:Number(sumpreCT/compUser.length).toFixed(2),
          postTestScore:Number(sumpostCT/compUser.length).toFixed(2),
          nam:'',
          age:nCont+','+nExp,
          std:'',
          susScore:Number(sumIBMCT/compUser.length).toFixed(2),
          completed:''
        })
        console.log(groupStatus)
        setpreEfficacy(preEfficacy)
        setpostEfficacy(postEfficacy)
        setgroupSession(groupStatus)
    //  getData(sesId)

    //     try{
    //       getData(sesId)
    //       interval = setInterval(() => {
    //           //console.log('Interval is working')
    //           getData(sesId);
    //       }, 10000);
  
     
    // } catch (error) {
    //     if (axios.isCancel(error)) {
    //       console.log("cancelled");
    //     } else {
    //       throw error;
    //     }
    //   }

        setloading(false)

      })



      })
      .catch((error)=>{
      console.log(error);
      });
    }

    loadData();


    return() => {source.cancel();};
     
   }, []);
    
    console.log(groupSession)
      //console.log(sess)
    const theme = useTheme() 
    const classes = styles(theme);

  //const groupSession=[]    
   const studentlist = clas.students;
   const teacherlist = clas.coTeachers;


       const getData = (sessid) =>{
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
      
        axios.get(`${baseUrl}pyinterpreter/profile`, { cancelToken: source.token })
      .then((response) =>{
        console.log(response.data)
        const sess=response.data.filter((ses)=> ses.sessionId == sessid)
        //console.log(sess);
        setsess(sess)
        setgroups(response.data)
        var grpNo = 0;
        var groupStatus = [];
        var currStatus='';
        sess.map((grp) => {
          grpNo++;

          var preScore = 0
          var postScore = 0
          if(grp.preTest[0].bebras.includes(',')){
            var score=0
            var arr = grp.preTest[0].bebras.split(',')
            ///que1
          if(arr[0]==='Option2'){
            score = score+2
          }
          if(arr[1]=='Option1'){
            score = score+2
          }
          if(arr[2]=='Option1'){
            score = score+2
          }///que2
          if(arr[3]=='Option1'){
            score = score+1.5
          }
          if(arr[4]=='Option2'){
            score = score+1.5
          }
          if(arr[5]=='Option3'){
            score = score+1.5
          }
          if(arr[6]=='Option1'){
            score = score+1.5
          }///que3
          if(arr[7]==='Option1'){
            score = score+2
          }
          if(arr[8]=='Option4'){
            score = score+2
          }
          if(arr[9]=='Option1'){
            score = score+2
          }///que4
          if(arr[10]==='Option3'){
            score = score+3
          }
          if(arr[11]=='Option2'){
            score = score+3
          }
          ///que5
          if(arr[12]==='Option2'){
            score = score+4.5
          }
          if(arr[13]=='Option1'){
            score = score+4.5
          }///que6
          if(arr[14]==='Option1'){
            score = score+3
          }
          if(arr[15]=='Option1'){
            score = score+3
          }
          if(arr[16]=='Option4'){
            score = score+3
          }///que7
          if(arr[17]==='Option2'){
            score = score+3
          }
          if(arr[18]=='Option1'){
            score = score+3
          }
          if(arr[19]=='Option4'){
            score = score+3
          }///que8
          if(arr[20]==='Option1'){
            score = score+4.5
          }
          if(arr[21]=='Option3'){
            score = score+4.5
          }///que9
          if(arr[22]==='Option1'){
            score = score+12
          }///que10
          if(arr[23]==='Option2'){
            score = score+6
          }
          if(arr[24]=='Option2'){
            score = score+6
          }///que11
          if(arr[25]=='Option1'){
            score = score+3
          }
          if(arr[26]=='Option1'){
            score = score+3
          }
          if(arr[27]=='Option3'){
            score = score+3
          }
          if(arr[28]=='Option3'){
            score = score+3
          }///que12
          if(arr[29]==='Option3'){
            score = score+6
          }
          if(arr[30]=='Option3'){
            score = score+6
          }
          preScore=score
          }

          if(grp.postTest[0].bebras.includes(',')){
            var arr = grp.postTest[0].bebras.split(',')
            var score=0;
            ///que1
            if(arr[0]==='Option3'){
              score = score+3
            }
            if(arr[1]=='Option2'){
              score = score+3
            }///que2
            if(arr[2]=='Option3'){
              score = score+6
            }//que3
            if(arr[3]=='Option4'){
              score = score+2
            }
            if(arr[4]=='Option2'){
              score = score+2
            }
            if(arr[5]=='Option2'){
              score = score+2
            }//que4
            if(arr[6]=='Option1'){
              score = score+2
            }
            if(arr[7]==='Option3'){
              score = score+2
            }
            if(arr[8]=='Option4'){
              score = score+2
            }//que5
            if(arr[9]=='Option3'){
              score = score+3
            }
            if(arr[10]==='Option2'){
              score = score+3
            }
            if(arr[11]=='Option4'){
              score = score+3
            }
            ///que6
            if(arr[12]==='Option3'){
              score = score+4.5
            }
            if(arr[13]=='Option3'){
              score = score+4.5
            }///que7
            if(arr[14]==='Option1'){
              score = score+3
            }
            if(arr[15]=='Option2'){
              score = score+3
            }
            if(arr[16]=='Option2'){
              score = score+3
            }///que8
            if(arr[17]==='Option2'){
              score = score+4.5
            }
            if(arr[18]=='Option1'){
              score = score+4.5
            }//que9
            if(arr[19]=='Option3'){
              score = score+4
            }
            if(arr[20]==='Option2'){
              score = score+4
            }
            if(arr[21]=='Option3'){
              score = score+4
            }///que10
            if(arr[22]==='Option1'){
              score = score+4
            }
            if(arr[23]==='Option1'){
              score = score+4
            }
            if(arr[24]=='Option3'){
              score = score+4
            }///que11
            if(arr[25]=='Option3'){
              score = score+4
            }
            if(arr[26]=='Option3'){
              score = score+4
            }
            if(arr[27]=='Option2'){
              score = score+4
            }///que12
            if(arr[28]=='Option2'){
              score = score+4
            }
            if(arr[29]==='Option1'){
              score = score+4
            }
            if(arr[30]=='Option3'){
              score = score+4
            }
            
            postScore=score
          }
          var name='';
          var age = 0;
          var gender='Male';
          var std='IX';
          var section='';
          var preClass=false;
          var progLang = ''
          if(grp.preTest[0].initial.includes(',')==true){
            var narr = grp.preTest[0].initial.split(',')
            name = narr[0]
            gender = narr[2]
            std = narr[3]
            section = narr[4]
            preClass = narr[5]
            progLang = narr[6]
            age = getAge(narr[1])
            console.log('Age: '+age+' '+narr[1])
          }
          var totscore = 0
          if(grp.postTest[0].ibmsus.includes(';')==true){
            var scr = grp.postTest[0].ibmsus.split(';')
            scr.map((val, index)=>{
              if(index<10){
              if((index+1)%2==0){
                totscore = totscore+(5-getScore(val))
              }
              else{
                totscore = totscore+(getScore(val)-1)
              }
              console.log(getScore(val))
              }
            })
          }


          if(grp.currentActivity!==''){
              currStatus=grp.currentActivity
            
            groupStatus.push({
              id:grp._id,
              userId:'User'+grpNo,
              userName:grp.userId,
              supportChat: grp.support,
              lastViewSupport:grp.lastViewSupport,
              currentStatus:currStatus,
              preTestScore:preScore,
              postTestScore:postScore,
              nam:name,
              age:age,
              gender:gender,
              std:std,
              section:section,
              preClass:preClass,
              progLang:progLang,
              susScore:totscore,
              completed:grp.postTest[0].completed
            })
          }
        })
        console.log(groupStatus)
        var len = groupSession.length

        for(var i=0;i<len-1;i++){
            groupSession.pop()
          }
        setgroupSession(groupStatus)

      })

      
      
      } 

  const handleAccordionChange1 = (panel) => (event, isExpanded) => {    
        setExpanded1(isExpanded ? panel : false);
    };

  const getAge = (dateString) => {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

const getScore = (sco) => {
  var score = 0;
  if(sco=='Strongly disagree'){
    score = 1
  }
  else if(sco=='Disagree'){
    score = 2
  }
  else if(sco=='Neutral'){
    score = 3
  }
  else if(sco=='Agree'){
    score = 4
  }
  else if(sco=='Strongly agree'){
    score = 5
  }
  return score
}

const groupTotalStatus = (group)=>{

    console.log(group)
    var status = [];
    var newIndex=0;
    ['activity1', 'activity2', 'activity3', 'activity4','activity5','activity6', 'activity7'].map((text, index) =>{
      if(group.currentStatus==text){
        newIndex=index;
      status.push({
        currStatus:text,
        stats:'Completed'
      })
      }
      else{
        status.push({
          currStatus:text,
          stats:'Working'
        })
      }
    })

    console.log(newIndex)
    status.map((item, index) =>{
      if(index<newIndex){
        item.stats='Completed'
      }
      else if(index>newIndex){
        item.stats='Not Started'
      }
      else if(index===newIndex){
        item.stats='Working'
      }
    })
    return(
      <List>
          {status.map((text, index)=>(
            <ListItem button key={index}>
              <ListItemText primary={text.currStatus} />
                {text.stats}
            </ListItem>
          ))}
      </List>
    );
}
          const toggleDrawer = (item, open) => (event) => {
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
              return;
            }
            // console.log(open)
            console.log(item.row)
            if(item!==null && open!==false){
                setgdetail(item.row);
            }
            setState(!state);
          };
        const list = (gdetail)=>(
          <div sx={{ width: 250 }} role="presentation"
          onKeyDown={toggleDrawer(gdetail, false)}>
            {console.log(gdetail)}
            <List>
            <ListItemText align='center'>{gdetail.userName} Status</ListItemText>
              {groupTotalStatus(gdetail)}

              
              <Divider/>
                
                <ListItemText align='center'>Need Attention</ListItemText>

                <ListItem key='5'>
                  <ListItemText primary={<Typography variant="body1" style={{ color: '#ff6f00' }}>Recent</Typography>} />
                  <ListItemText primary={<Typography variant="body1" style={{ color: '#ff6f00' }}>Activity</Typography>} />
                  <ListItemText primary={<Typography variant="body1" style={{ color: '#ff6f00' }}>Time</Typography>} />
                </ListItem>
                {/* {console.log(gdetail)} */}
                {typeof findquery(gdetail) !== 'undefined'?
                  findquery(gdetail).map((query) =>(

                    writeQuery(query)
                  
                  )):null}
                <ListItemText align='center'>
                  {loading!==true?
                    <Link color="inherit" to={`/admin/dashboard/viewclass/viewsession/${clas._id}/${sesId}/work/${gdetail.id}/${gdetail.userName}`}>
                      <Button color="rose" variant="contained" size="sm" > view work</Button>
                    </Link>
                    :null}
                </ListItemText>
                  
            </List>
          </div>
        );

 ////function to return the corresponding session details for selected session  
        const findquery=(sdetail) =>{
         
          const sessionQuery= Array.from(groupSession.filter((qry) => qry.userId==sdetail.userId));
          if(sessionQuery.length>0){
              return sessionQuery
          }
        }

        const writeQuery = (query) => {
          console.log(query)
          var newQuery = false;
          const length = query.supportChat.length;
          //console.log(length)
          var dateTime='';var time='';var date='';
          if(length>0){
           time = new Date(query.supportChat[length-1].created).toString().substring(15, 21);

           date = new Date(query.supportChat[0].created).toString().substring(3, 10);
          //if()
          dateTime = date+time;
          ///check for new queries
          const lastMsg = new Date(query.supportChat[length-1].created)
          const lastVisit = new Date(query.lastViewSupport)
          
          console.log(lastVisit)

          if(lastVisit < lastMsg){
            newQuery = true
          }
        
          
            return(
              <ListItem key= {query.groupId}>
                      <ListItemText sx={{ fontSize: "4" }} disableTypography> msg
                      {newQuery == true?'(new)' :'(seen)'}  
                      </ListItemText>
                      <ListItemText sx={{ fontSize: "4" }} disableTypography>{query.supportChat[length-1].activity}</ListItemText>
                   <ListItemText align="right" secondary={`${dateTime}`} ></ListItemText>
              </ListItem>
              );
          }
        }
    const checkStatus = (query)=>{
      const length = query.supportChat.length;
      console.log(query)
      var newQuery = false;
      if(length>0 && typeof(query)!='undefined' && typeof(length)!='undefined'){
      const lastMsg = new Date(query.supportChat[length-1].created)
      const lastVisit = new Date(query.lastViewSupport)
      console.log(lastVisit+','+lastMsg)

      if(lastVisit < lastMsg){
        newQuery = true
      }
    }
      if(newQuery==true){
        return '(new)'
      }

    }


    return(
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>

            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link color="inherit" to="/admin/dashboard">
                        Dashboard
                </Link>
                <Link color="inherit" to={`/admin/dashboard/viewclass/${clas._id}`}>
                    <Typography color="textPrimary">{clas.title}</Typography>
                </Link>
                {loading!==true?
                  <Typography color="textPrimary">
                    {status[0].title}
                  </Typography>
                :null}

            </Breadcrumbs>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
            </GridItem>
            <GridItem xs={12} sm={12} md={8}>
                <Typography color="textPrimary" variant="h5" className="text-center">
                    Monitoring Scenario 
                </Typography>
                
            </GridItem>
            {/* <GridItem xs={12} sm={12} md={4}>
            {loading!==true?
              <Link color="inherit" to={`/admin/dashboard/viewclass/${clas._id}/viewsession/${sess[0]._id}/finalassess`}>
                  <Button color="rose" variant="contained" size="sm" > Final Assessment </Button>
              </Link>
              :null}
            </GridItem> */}
            


            
            
          <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            title="Activities"
            headerColor="success"
            tabs={[
              {
                tabName: "Activity1",
                tabIcon: LiveHelpTwoToneIcon,
                 tabContent: 
                (
                  <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>User</StyledTableCell>
                        <StyledTableCell>Section</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell align="right">Current Stage</StyledTableCell>
                        <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupSession.map((row,index) => {
                          var k=1;
                          
                        return (
                        row.currentStatus === 'activity1'? 
                        <StyledTableRow key={row.id}>
                          <StyledTableCell component="th" scope="row">
                          {++index}. {row.userName}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.section}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.type}
                          </StyledTableCell>
                          <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                          <StyledTableCell align="right">
                              <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                                View Status {checkStatus(row)}
                              </Button>                        
                          </StyledTableCell>
                        </StyledTableRow>:null
                      )})}
                    </TableBody>
                  </Table>
                </TableContainer>             

                )
              },
              {
                tabName: "Activity2",
                tabIcon: MultilineChartIcon,
                tabContent: (
                
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>User</StyledTableCell>
                      <StyledTableCell>Section</StyledTableCell>
                      <StyledTableCell>Type</StyledTableCell>
                      <StyledTableCell align="right">Current Stage</StyledTableCell>
                      <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupSession.map((row,index) => {
                          var k=1;
                        return (
                      row.currentStatus === 'activity2'? 
                      <StyledTableRow key={row.id}>
                        <StyledTableCell component="th" scope="row">
                        {++index}. {row.userName}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                            {row.section}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                            {row.type}
                          </StyledTableCell>
                        <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                        <StyledTableCell align="right">
                            <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                              View Status {checkStatus(row)}
                            </Button>                        
                        </StyledTableCell>
                      </StyledTableRow>:null
                    )})}
                  </TableBody>
                </Table>
              </TableContainer>

                )
              },
              {
                tabName: "Activity3",
                tabIcon: DeveloperBoardIcon,
                tabContent: (

                  <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>User</StyledTableCell>
                        <StyledTableCell>Section</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell align="right">Current Stage</StyledTableCell>
                        <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupSession.map((row, index) => {
                          var k=1;
                        return (
                        row.currentStatus === 'activity3'? 
                        <StyledTableRow key={row.id}>
                          <StyledTableCell component="th" scope="row">
                          {++index}. {row.userName}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.section}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.type}
                          </StyledTableCell>
                          <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                          <StyledTableCell align="right">
                              <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                                View Status {checkStatus(row)}
                              </Button>                        
                          </StyledTableCell>
                        </StyledTableRow>:null
                      )})}
                    </TableBody>
                  </Table>
                </TableContainer>
                )
              },
              {
                tabName: "Activity4",
                tabIcon: ForumIcon,
                tabContent: (

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>User</StyledTableCell>
                      <StyledTableCell>Section</StyledTableCell>
                      <StyledTableCell>Type</StyledTableCell>
                      <StyledTableCell align="right">Current Stage</StyledTableCell>
                      <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupSession.map((row, index) => {
                          var k=1;
                        return (
                      row.currentStatus === 'activity4'? 
                      <StyledTableRow key={row.id}>
                        <StyledTableCell component="th" scope="row">
                        {++index}. {row.userName}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.section}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                            {row.type}
                          </StyledTableCell>
                        <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                        <StyledTableCell align="right">
                            <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                              View Status {checkStatus(row)}
                            </Button>                        
                        </StyledTableCell>
                      </StyledTableRow>:null
                    )})}
                  </TableBody>
                </Table>
              </TableContainer>
                )
              },
              {
                tabName: "Activity5",
                tabIcon: AssignmentIcon,
                tabContent: (

                  <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>User</StyledTableCell>
                        <StyledTableCell>Section</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell align="right">Current Stage</StyledTableCell>
                        <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupSession.map((row, index) => {
                          var k=1;
                        return (
                        row.currentStatus === 'activity5'? 
                        <StyledTableRow key={row.id}>
                          <StyledTableCell component="th" scope="row">
                          {++index}. {row.userName}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.section}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.type}
                          </StyledTableCell>
                          <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                          <StyledTableCell align="right">
                              <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                                View Status {checkStatus(row)}
                              </Button>                        
                          </StyledTableCell>
                        </StyledTableRow>:null
                      )})}
                    </TableBody>
                  </Table>
                </TableContainer>
                )
              },
              {
                tabName: "activity6",
                tabIcon: AssignmentTurnedInTwoToneIcon,
                tabContent: (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>User</StyledTableCell>
                        <StyledTableCell>Section</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell align="right">Current Stage</StyledTableCell>
                        <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupSession.map((row, index) => {
                          var k=1;
                        return (
                        row.currentStatus === 'activity6' && row.completed==false? 
                        <StyledTableRow key={row.id}>
                          <StyledTableCell component="th" scope="row">
                          {++index}. {row.userName}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.section}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.type}
                          </StyledTableCell>
                          <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                          <StyledTableCell align="right">
                              <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                                View Status {checkStatus(row)}
                              </Button>                        
                          </StyledTableCell>
                        </StyledTableRow>:null
                      )})}
                    </TableBody>
                  </Table>
                </TableContainer>
                )
              },
              {
                tabName: "completed",
                tabIcon: AssignmentTurnedInTwoToneIcon,
                tabContent: (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>User</StyledTableCell>
                        <StyledTableCell>Section</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell align="right">Current Stage</StyledTableCell>
                        <StyledTableCell align="right">Status&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupSession.map((row, index) => {
                          var k=1;
                        return (
                        row.completed === true? 
                        <StyledTableRow key={row.id}>
                          <StyledTableCell component="th" scope="row">
                          {++index}. {row.userName}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.section}
                          </StyledTableCell>
                          <StyledTableCell align="right">{row.currentStatus}</StyledTableCell>
                          <StyledTableCell align="right">
                              <Button color="warning" variant="contained" onClick={toggleDrawer({row}, true)} >
                                View Status {checkStatus(row)}
                              </Button>                        
                          </StyledTableCell>
                        </StyledTableRow>:null
                      )})}
                    </TableBody>
                  </Table>
                </TableContainer>
                )
              }
            ]}
          />
        {console.log(gdetail)}
        <Drawer anchor={'right'} open={state} onClose={toggleDrawer(gdetail,false)}>
            
            {list(gdetail)}
        </Drawer>

        </GridItem>
        <Card>
          <CardHeader color="rose">
            <h3 className={classes.cardTitleWhite}> User details</h3>
          </CardHeader>
          <CardBody>
          <Accordion expanded={expanded1 === 'panel3'} onChange={handleAccordionChange1('panel3')}>
                              <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    >
                                    <Typography className={classes.heading}>User details in Experiment </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <TableContainer component={Paper}>
                                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCell>User</StyledTableCell>
                                        <StyledTableCell>Age</StyledTableCell>
                                        <StyledTableCell>Gender</StyledTableCell>
                                        <StyledTableCell>Section</StyledTableCell>
                                        <StyledTableCell>pre-implemetation</StyledTableCell>
                                        <StyledTableCell>progLang</StyledTableCell>
                                        <StyledTableCell align="right">PreTest score</StyledTableCell>
                                        <StyledTableCell align="right">PostTest score&nbsp;</StyledTableCell>
                                        <StyledTableCell align="right">SUS score&nbsp;</StyledTableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {groupSession.map((row,index) => (
                                        <StyledTableRow key={row.id}>
                                          <StyledTableCell component="th" scope="row">
                                            {++index}. {row.userName}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.age}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.gender}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.section}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.preClass}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.progLang}
                                          </StyledTableCell>
                                          <StyledTableCell align="right">{row.preTestScore}</StyledTableCell>
                                          <StyledTableCell align="right">{row.postTestScore}</StyledTableCell>
                                          <StyledTableCell align="right">{row.susScore*2.5}</StyledTableCell>
                                        </StyledTableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                    </AccordionDetails>
                    </Accordion>
                    </CardBody>
                  </Card>
                    
                      <Card>
                        <CardHeader color="info">
                          <h3 className={classes.cardTitleWhite}> Pre-Test Self-efficacy</h3>
                        </CardHeader>
                        <CardBody>
                          <Accordion expanded={expanded1 === 'panel1'} onChange={handleAccordionChange1('panel1')}>
                              <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    >
                                    <Typography className={classes.heading}>PreTest Self-efficacy </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <TableContainer component={Paper}>
                                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCell>User</StyledTableCell>
                                        <StyledTableCell>q1</StyledTableCell>
                                        <StyledTableCell>q2</StyledTableCell>
                                        <StyledTableCell>q3</StyledTableCell>
                                        <StyledTableCell>q4</StyledTableCell>
                                        <StyledTableCell>q5</StyledTableCell>
                                        <StyledTableCell>q6</StyledTableCell>
                                        <StyledTableCell>q7</StyledTableCell>
                                        <StyledTableCell>q8</StyledTableCell>
                                        <StyledTableCell>q9</StyledTableCell>
                                        <StyledTableCell>q10</StyledTableCell>
                                        <StyledTableCell>q11</StyledTableCell>
                                        <StyledTableCell>q12</StyledTableCell>
                                        <StyledTableCell>q13</StyledTableCell>
                                        <StyledTableCell>q14</StyledTableCell>
                                        <StyledTableCell>q15</StyledTableCell>
                                        <StyledTableCell>q16</StyledTableCell>
                                        <StyledTableCell>q17</StyledTableCell>
                                        <StyledTableCell>q18</StyledTableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {preEfficacy.map((row,index) => (
                                      <StyledTableRow key={row.userName}>
                                        <StyledTableCell component="th" scope="row">
                                          {++index}. {row.userName}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q1}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q2}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q3}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q4}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q5}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q6}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q7}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q8}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q9}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q10}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q11}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q12}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q13}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q14}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q15}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q16}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q17}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          {row.q18}
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </AccordionDetails>
                          </Accordion>
                        </CardBody>
                      </Card>

                    <Card>
                      <CardHeader color="rose">
                        <h3 className={classes.cardTitleWhite}> Completed User details</h3>
                      </CardHeader>
                      <CardBody>
                        <Accordion expanded={expanded1 === 'panel20'} onChange={handleAccordionChange1('panel20')}>
                              <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    >
                                    <Typography className={classes.heading}>User details in Experiment </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <TableContainer component={Paper}>
                                  <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCell>User</StyledTableCell>
                                        <StyledTableCell>Age</StyledTableCell>
                                        <StyledTableCell>Gender</StyledTableCell>
                                        <StyledTableCell>Section</StyledTableCell>
                                        <StyledTableCell>pre-implemetation</StyledTableCell>
                                        <StyledTableCell>progLang</StyledTableCell>
                                        <StyledTableCell>type</StyledTableCell>
                                        <StyledTableCell align="right">PreTest score</StyledTableCell>
                                        <StyledTableCell align="right">PostTest score&nbsp;</StyledTableCell>
                                        <StyledTableCell align="right">SUS score&nbsp;</StyledTableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {compUser.map((row,index) => (
                                        <StyledTableRow key={row.id}>
                                          <StyledTableCell component="th" scope="row">
                                            {++index}. {row.userName}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.age}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.gender}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.section}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.preClass}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.progLang}
                                          </StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {row.type}
                                          </StyledTableCell>
                                          <StyledTableCell align="right">{row.preTestScore}</StyledTableCell>
                                          <StyledTableCell align="right">{row.postTestScore}</StyledTableCell>
                                          <StyledTableCell align="right">{row.susScore*2.5}</StyledTableCell>
                                        </StyledTableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                          </AccordionDetails>
                        </Accordion>
                      </CardBody>
                    </Card>
                  
                  <Card>
                    <CardHeader color="info">
                       <h3 className={classes.cardTitleWhite}> Post-Test Self-efficacy</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel2'} onChange={handleAccordionChange1('panel2')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>PostTest Self-efficacy </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>User</StyledTableCell>
                                    <StyledTableCell>q1</StyledTableCell>
                                    <StyledTableCell>q2</StyledTableCell>
                                    <StyledTableCell>q3</StyledTableCell>
                                    <StyledTableCell>q4</StyledTableCell>
                                    <StyledTableCell>q5</StyledTableCell>
                                    <StyledTableCell>q6</StyledTableCell>
                                    <StyledTableCell>q7</StyledTableCell>
                                    <StyledTableCell>q8</StyledTableCell>
                                    <StyledTableCell>q9</StyledTableCell>
                                    <StyledTableCell>q10</StyledTableCell>
                                    <StyledTableCell>q11</StyledTableCell>
                                    <StyledTableCell>q12</StyledTableCell>
                                    <StyledTableCell>q13</StyledTableCell>
                                    <StyledTableCell>q14</StyledTableCell>
                                    <StyledTableCell>q15</StyledTableCell>
                                    <StyledTableCell>q16</StyledTableCell>
                                    <StyledTableCell>q17</StyledTableCell>
                                    <StyledTableCell>q18</StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                {postEfficacy.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q2}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q3}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q4}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q5}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q6}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q7}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q8}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q9}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q10}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q11}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q12}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q13}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q14}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q15}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q16}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q17}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q18}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
                
                
                <Card>
                    <CardHeader color="info">
                       <h3 className={classes.cardTitleWhite}> Student Feedback</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel5'} onChange={handleAccordionChange1('panel5')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Student Feedback </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>User</StyledTableCell>
                                    <StyledTableCell>any prev exp?</StyledTableCell>
                                    <StyledTableCell>rate</StyledTableCell>
                                    <StyledTableCell>app useful?</StyledTableCell>
                                    <StyledTableCell>what you liked?</StyledTableCell>
                                    <StyledTableCell>any difficulty?</StyledTableCell>
                                    <StyledTableCell>suggestion?</StyledTableCell>
                                    <StyledTableCell>overall suggestion</StyledTableCell>
                                    <StyledTableCell>goal or benefits</StyledTableCell>
                                    <StyledTableCell>motivate friends?</StyledTableCell>
                                    <StyledTableCell>anything else?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                {feedback.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q2}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q3}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q4}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q5}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q6}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q7}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q8}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q9}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q10}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
                
                <Card>
                    <CardHeader color="info">
                       <h3 className={classes.cardTitleWhite}> SUS Questionnaire</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>SUS Questionnaire </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>User</StyledTableCell>
                                    <StyledTableCell>use frequently?</StyledTableCell>
                                    <StyledTableCell>unnecessarily complex?</StyledTableCell>
                                    <StyledTableCell>app easy?</StyledTableCell>
                                    <StyledTableCell>any technical support?</StyledTableCell>
                                    <StyledTableCell>function integrated?</StyledTableCell>
                                    <StyledTableCell>too inconsistent?</StyledTableCell>
                                    <StyledTableCell>learn quickly</StyledTableCell>
                                    <StyledTableCell>too cumbersome</StyledTableCell>
                                    <StyledTableCell>felt confident?</StyledTableCell>
                                    <StyledTableCell>need to learn lot of things?</StyledTableCell>
                                    <StyledTableCell>final score</StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                {susibm.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q2}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q3}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q4}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q5}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q6}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q7}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q8}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q9}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.q10}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.score*2.5}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
               
                  <Card>
                    <CardHeader color="success">
                       <h3 className={classes.cardTitleWhite}> Activity1 Details</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel10'} onChange={handleAccordionChange1('panel10')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Activity 1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>UserName</StyledTableCell>
                                    <StyledTableCell>totAltSol</StyledTableCell>
                                    <StyledTableCell>totAtt</StyledTableCell>
                                    <StyledTableCell>totSelAtt</StyledTableCell>
                                    <StyledTableCell>hintScore</StyledTableCell>
                                    <StyledTableCell>decAtt</StyledTableCell>
                                    <StyledTableCell>decHint</StyledTableCell>
                                    <StyledTableCell>decTime</StyledTableCell>
                                    <StyledTableCell>decAltAtt</StyledTableCell>
                                    <StyledTableCell>decAltTime</StyledTableCell>
                                    <StyledTableCell>decAltSol</StyledTableCell>
                                    <StyledTableCell>patAtt</StyledTableCell>
                                    <StyledTableCell>patHint</StyledTableCell>
                                    <StyledTableCell>patTime</StyledTableCell>
                                    <StyledTableCell>patAltAtt</StyledTableCell>
                                    <StyledTableCell>patAltTime</StyledTableCell>
                                    <StyledTableCell>patAltSol</StyledTableCell>
                                    <StyledTableCell>absAtt</StyledTableCell>
                                    <StyledTableCell>absHint</StyledTableCell>
                                    <StyledTableCell>absTime</StyledTableCell>
                                    <StyledTableCell>absAltAtt</StyledTableCell>
                                    <StyledTableCell>absAltTime</StyledTableCell>
                                    <StyledTableCell>absAltSol</StyledTableCell>
                                    <StyledTableCell>algAtt</StyledTableCell>
                                    <StyledTableCell>algHint</StyledTableCell>
                                    <StyledTableCell>algTime</StyledTableCell>
                                    <StyledTableCell>algAltAtt</StyledTableCell>
                                    <StyledTableCell>algAltTime</StyledTableCell>
                                    <StyledTableCell>algAltSol</StyledTableCell>
                                    <StyledTableCell>anaAtt</StyledTableCell>
                                    <StyledTableCell>anaHint</StyledTableCell>
                                    <StyledTableCell>anaTime</StyledTableCell>
                                    <StyledTableCell>anaAltAtt</StyledTableCell>
                                    <StyledTableCell>decSelAtt</StyledTableCell>
                                    <StyledTableCell>patSelAtt</StyledTableCell>
                                    <StyledTableCell>absSelAtt</StyledTableCell>
                                    <StyledTableCell>algSelAtt</StyledTableCell>
                                    <StyledTableCell>anaSelAtt</StyledTableCell>
                                    <StyledTableCell>better sol?</StyledTableCell>
                                    <StyledTableCell>less operation?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
  
                                <TableBody>
                                {analyticStatus.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totHintScore}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que2}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>

                
                  <Card>
                    <CardHeader color="success">
                       <h3 className={classes.cardTitleWhite}> Activity2 Details</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Activity 2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>UserName</StyledTableCell>
                                    <StyledTableCell>totAltSol</StyledTableCell>
                                    <StyledTableCell>totAtt</StyledTableCell>
                                    <StyledTableCell>totSelAtt</StyledTableCell>
                                    <StyledTableCell>hintScore</StyledTableCell>
                                    <StyledTableCell>decAtt</StyledTableCell>
                                    <StyledTableCell>decHint</StyledTableCell>
                                    <StyledTableCell>decTime</StyledTableCell>
                                    <StyledTableCell>decAltAtt</StyledTableCell>
                                    <StyledTableCell>decAltTime</StyledTableCell>
                                    <StyledTableCell>decAltSol</StyledTableCell>
                                    <StyledTableCell>patAtt</StyledTableCell>
                                    <StyledTableCell>patHint</StyledTableCell>
                                    <StyledTableCell>patTime</StyledTableCell>
                                    <StyledTableCell>patAltAtt</StyledTableCell>
                                    <StyledTableCell>patAltTime</StyledTableCell>
                                    <StyledTableCell>patAltSol</StyledTableCell>
                                    <StyledTableCell>absAtt</StyledTableCell>
                                    <StyledTableCell>absHint</StyledTableCell>
                                    <StyledTableCell>absTime</StyledTableCell>
                                    <StyledTableCell>absAltAtt</StyledTableCell>
                                    <StyledTableCell>absAltTime</StyledTableCell>
                                    <StyledTableCell>absAltSol</StyledTableCell>
                                    <StyledTableCell>algAtt</StyledTableCell>
                                    <StyledTableCell>algHint</StyledTableCell>
                                    <StyledTableCell>algTime</StyledTableCell>
                                    <StyledTableCell>algAltAtt</StyledTableCell>
                                    <StyledTableCell>algAltTime</StyledTableCell>
                                    <StyledTableCell>algAltSol</StyledTableCell>
                                    <StyledTableCell>anaAtt</StyledTableCell>
                                    <StyledTableCell>anaHint</StyledTableCell>
                                    <StyledTableCell>anaTime</StyledTableCell>
                                    <StyledTableCell>anaAltAtt</StyledTableCell>
                                    <StyledTableCell>decSelAtt</StyledTableCell>
                                    <StyledTableCell>patSelAtt</StyledTableCell>
                                    <StyledTableCell>absSelAtt</StyledTableCell>
                                    <StyledTableCell>algSelAtt</StyledTableCell>
                                    <StyledTableCell>anaSelAtt</StyledTableCell>
                                    <StyledTableCell>better sol?</StyledTableCell>
                                    <StyledTableCell>less operation?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
  
                                <TableBody>
                                {analyticStatus2.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totHintScore}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que2}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
                
                  <Card>
                    <CardHeader color="success">
                       <h3 className={classes.cardTitleWhite}> Activity3 Details</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel13'} onChange={handleAccordionChange1('panel13')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Activity 3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>UserName</StyledTableCell>
                                    <StyledTableCell>totAltSol</StyledTableCell>
                                    <StyledTableCell>totAtt</StyledTableCell>
                                    <StyledTableCell>totSelAtt</StyledTableCell>
                                    <StyledTableCell>hintScore</StyledTableCell>
                                    <StyledTableCell>decAtt</StyledTableCell>
                                    <StyledTableCell>decHint</StyledTableCell>
                                    <StyledTableCell>decTime</StyledTableCell>
                                    <StyledTableCell>decAltAtt</StyledTableCell>
                                    <StyledTableCell>decAltTime</StyledTableCell>
                                    <StyledTableCell>decAltSol</StyledTableCell>
                                    <StyledTableCell>patAtt</StyledTableCell>
                                    <StyledTableCell>patHint</StyledTableCell>
                                    <StyledTableCell>patTime</StyledTableCell>
                                    <StyledTableCell>patAltAtt</StyledTableCell>
                                    <StyledTableCell>patAltTime</StyledTableCell>
                                    <StyledTableCell>patAltSol</StyledTableCell>
                                    <StyledTableCell>absAtt</StyledTableCell>
                                    <StyledTableCell>absHint</StyledTableCell>
                                    <StyledTableCell>absTime</StyledTableCell>
                                    <StyledTableCell>absAltAtt</StyledTableCell>
                                    <StyledTableCell>absAltTime</StyledTableCell>
                                    <StyledTableCell>absAltSol</StyledTableCell>
                                    <StyledTableCell>algAtt</StyledTableCell>
                                    <StyledTableCell>algHint</StyledTableCell>
                                    <StyledTableCell>algTime</StyledTableCell>
                                    <StyledTableCell>algAltAtt</StyledTableCell>
                                    <StyledTableCell>algAltTime</StyledTableCell>
                                    <StyledTableCell>algAltSol</StyledTableCell>
                                    <StyledTableCell>anaAtt</StyledTableCell>
                                    <StyledTableCell>anaHint</StyledTableCell>
                                    <StyledTableCell>anaTime</StyledTableCell>
                                    <StyledTableCell>anaAltAtt</StyledTableCell>
                                    <StyledTableCell>decSelAtt</StyledTableCell>
                                    <StyledTableCell>patSelAtt</StyledTableCell>
                                    <StyledTableCell>absSelAtt</StyledTableCell>
                                    <StyledTableCell>algSelAtt</StyledTableCell>
                                    <StyledTableCell>anaSelAtt</StyledTableCell>
                                    <StyledTableCell>better sol?</StyledTableCell>
                                    <StyledTableCell>less operation?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
  
                                <TableBody>
                                {analyticStatus3.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totHintScore}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que2}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
               
                  <Card>
                    <CardHeader color="success">
                       <h3 className={classes.cardTitleWhite}> Activity4 Details</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel14'} onChange={handleAccordionChange1('panel14')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Activity 4 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>UserName</StyledTableCell>
                                    <StyledTableCell>totAltSol</StyledTableCell>
                                    <StyledTableCell>totAtt</StyledTableCell>
                                    <StyledTableCell>totSelAtt</StyledTableCell>
                                    <StyledTableCell>hintScore</StyledTableCell>
                                    <StyledTableCell>decAtt</StyledTableCell>
                                    <StyledTableCell>decHint</StyledTableCell>
                                    <StyledTableCell>decTime</StyledTableCell>
                                    <StyledTableCell>decAltAtt</StyledTableCell>
                                    <StyledTableCell>decAltTime</StyledTableCell>
                                    <StyledTableCell>decAltSol</StyledTableCell>
                                    <StyledTableCell>patAtt</StyledTableCell>
                                    <StyledTableCell>patHint</StyledTableCell>
                                    <StyledTableCell>patTime</StyledTableCell>
                                    <StyledTableCell>patAltAtt</StyledTableCell>
                                    <StyledTableCell>patAltTime</StyledTableCell>
                                    <StyledTableCell>patAltSol</StyledTableCell>
                                    <StyledTableCell>absAtt</StyledTableCell>
                                    <StyledTableCell>absHint</StyledTableCell>
                                    <StyledTableCell>absTime</StyledTableCell>
                                    <StyledTableCell>absAltAtt</StyledTableCell>
                                    <StyledTableCell>absAltTime</StyledTableCell>
                                    <StyledTableCell>absAltSol</StyledTableCell>
                                    <StyledTableCell>algAtt</StyledTableCell>
                                    <StyledTableCell>algHint</StyledTableCell>
                                    <StyledTableCell>algTime</StyledTableCell>
                                    <StyledTableCell>algAltAtt</StyledTableCell>
                                    <StyledTableCell>algAltTime</StyledTableCell>
                                    <StyledTableCell>algAltSol</StyledTableCell>
                                    <StyledTableCell>anaAtt</StyledTableCell>
                                    <StyledTableCell>anaHint</StyledTableCell>
                                    <StyledTableCell>anaTime</StyledTableCell>
                                    <StyledTableCell>anaAltAtt</StyledTableCell>
                                    <StyledTableCell>decSelAtt</StyledTableCell>
                                    <StyledTableCell>patSelAtt</StyledTableCell>
                                    <StyledTableCell>absSelAtt</StyledTableCell>
                                    <StyledTableCell>algSelAtt</StyledTableCell>
                                    <StyledTableCell>anaSelAtt</StyledTableCell>
                                    <StyledTableCell>better sol?</StyledTableCell>
                                    <StyledTableCell>less operation?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
  
                                <TableBody>
                                {analyticStatus4.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totHintScore}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que2}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
               
                  <Card>
                    <CardHeader color="success">
                       <h3 className={classes.cardTitleWhite}> Activity5 Details</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel15'} onChange={handleAccordionChange1('panel15')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Activity 5 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>UserName</StyledTableCell>
                                    <StyledTableCell>totAltSol</StyledTableCell>
                                    <StyledTableCell>totAtt</StyledTableCell>
                                    <StyledTableCell>totSelAtt</StyledTableCell>
                                    <StyledTableCell>hintScore</StyledTableCell>
                                    <StyledTableCell>decAtt</StyledTableCell>
                                    <StyledTableCell>decHint</StyledTableCell>
                                    <StyledTableCell>decTime</StyledTableCell>
                                    <StyledTableCell>decAltAtt</StyledTableCell>
                                    <StyledTableCell>decAltTime</StyledTableCell>
                                    <StyledTableCell>decAltSol</StyledTableCell>
                                    <StyledTableCell>patAtt</StyledTableCell>
                                    <StyledTableCell>patHint</StyledTableCell>
                                    <StyledTableCell>patTime</StyledTableCell>
                                    <StyledTableCell>patAltAtt</StyledTableCell>
                                    <StyledTableCell>patAltTime</StyledTableCell>
                                    <StyledTableCell>patAltSol</StyledTableCell>
                                    <StyledTableCell>absAtt</StyledTableCell>
                                    <StyledTableCell>absHint</StyledTableCell>
                                    <StyledTableCell>absTime</StyledTableCell>
                                    <StyledTableCell>absAltAtt</StyledTableCell>
                                    <StyledTableCell>absAltTime</StyledTableCell>
                                    <StyledTableCell>absAltSol</StyledTableCell>
                                    <StyledTableCell>algAtt</StyledTableCell>
                                    <StyledTableCell>algHint</StyledTableCell>
                                    <StyledTableCell>algTime</StyledTableCell>
                                    <StyledTableCell>algAltAtt</StyledTableCell>
                                    <StyledTableCell>algAltTime</StyledTableCell>
                                    <StyledTableCell>algAltSol</StyledTableCell>
                                    <StyledTableCell>anaAtt</StyledTableCell>
                                    <StyledTableCell>anaHint</StyledTableCell>
                                    <StyledTableCell>anaTime</StyledTableCell>
                                    <StyledTableCell>anaAltAtt</StyledTableCell>
                                    <StyledTableCell>decSelAtt</StyledTableCell>
                                    <StyledTableCell>patSelAtt</StyledTableCell>
                                    <StyledTableCell>absSelAtt</StyledTableCell>
                                    <StyledTableCell>algSelAtt</StyledTableCell>
                                    <StyledTableCell>anaSelAtt</StyledTableCell>
                                    <StyledTableCell>better sol?</StyledTableCell>
                                    <StyledTableCell>less operation?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
  
                                <TableBody>
                                {analyticStatus5.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totHintScore}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que2}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
                
                  <Card>
                    <CardHeader color="success">
                       <h3 className={classes.cardTitleWhite}> Activity6 Details</h3>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded1 === 'panel16'} onChange={handleAccordionChange1('panel16')}>
                        <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              >
                              <Typography className={classes.heading}>Activity 6 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>UserName</StyledTableCell>
                                    <StyledTableCell>totAltSol</StyledTableCell>
                                    <StyledTableCell>totAtt</StyledTableCell>
                                    <StyledTableCell>totSelAtt</StyledTableCell>
                                    <StyledTableCell>hintScore</StyledTableCell>
                                    <StyledTableCell>decAtt</StyledTableCell>
                                    <StyledTableCell>decHint</StyledTableCell>
                                    <StyledTableCell>decTime</StyledTableCell>
                                    <StyledTableCell>decAltAtt</StyledTableCell>
                                    <StyledTableCell>decAltTime</StyledTableCell>
                                    <StyledTableCell>decAltSol</StyledTableCell>
                                    <StyledTableCell>patAtt</StyledTableCell>
                                    <StyledTableCell>patHint</StyledTableCell>
                                    <StyledTableCell>patTime</StyledTableCell>
                                    <StyledTableCell>patAltAtt</StyledTableCell>
                                    <StyledTableCell>patAltTime</StyledTableCell>
                                    <StyledTableCell>patAltSol</StyledTableCell>
                                    <StyledTableCell>absAtt</StyledTableCell>
                                    <StyledTableCell>absHint</StyledTableCell>
                                    <StyledTableCell>absTime</StyledTableCell>
                                    <StyledTableCell>absAltAtt</StyledTableCell>
                                    <StyledTableCell>absAltTime</StyledTableCell>
                                    <StyledTableCell>absAltSol</StyledTableCell>
                                    <StyledTableCell>algAtt</StyledTableCell>
                                    <StyledTableCell>algHint</StyledTableCell>
                                    <StyledTableCell>algTime</StyledTableCell>
                                    <StyledTableCell>algAltAtt</StyledTableCell>
                                    <StyledTableCell>algAltTime</StyledTableCell>
                                    <StyledTableCell>algAltSol</StyledTableCell>
                                    <StyledTableCell>anaAtt</StyledTableCell>
                                    <StyledTableCell>anaHint</StyledTableCell>
                                    <StyledTableCell>anaTime</StyledTableCell>
                                    <StyledTableCell>anaAltAtt</StyledTableCell>
                                    <StyledTableCell>decSelAtt</StyledTableCell>
                                    <StyledTableCell>patSelAtt</StyledTableCell>
                                    <StyledTableCell>absSelAtt</StyledTableCell>
                                    <StyledTableCell>algSelAtt</StyledTableCell>
                                    <StyledTableCell>anaSelAtt</StyledTableCell>
                                    <StyledTableCell>better sol?</StyledTableCell>
                                    <StyledTableCell>less operation?</StyledTableCell>
                                  </TableRow>
                                </TableHead>
  
                                <TableBody>
                                {analyticStatus6.map((row,index) => (
                                  <StyledTableRow key={row.userName}>
                                    <StyledTableCell component="th" scope="row">
                                      {++index}. {row.userName}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.totHintScore}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAlttime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algAltSol}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAttempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaHints}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaTime}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaAltattempts}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.decSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.patSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.absSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.algSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.anaSelAtt}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que1}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                      {row.que2}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </CardBody>
                  </Card>
                
        <GridItem xs={12} sm={12} md={4}>
                <Card>
                <CardHeader color="info" align="center">
                    <h4 className={classes.cardCategoryWhite}> About Session </h4>
                </CardHeader>
                {loading!==true?
                <CardBody>

                    <p>Title: {status[0].title}</p>
                </CardBody>
                  :null}

                </Card>
            </GridItem>
  
        </GridContainer>
    );
}